import { Attributes, Misc, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import BusinessUnit from './BusinessUnit';

@NeoModel
export default class Branch extends ModelBase {
    static typeName = "Branch";

    public branchId: number = 0;

    @Attributes.Parent(() => BusinessUnit)
    public businessUnit: BusinessUnit | null = null;

    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public businessUnitId: number | null = null;

    @Rules.StringLength(10)
    @Rules.Required()
    @Attributes.Display("Branch number")
    public branchNo: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.branchNo) {
            return "New branch";
        } else {
            return this.branchNo;
        }
    }
}